import Swiper from 'swiper';
import { refs, domReady, booleanDataset } from '../modules/utils.js';

class ProductTop extends HTMLElement {
  static get observedAttributes() {
    return ['data-slider-index'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'data-slider-index') {
      const index = parseInt(newValue, 10);
      this.refs.thumbnails?.forEach((el, i) => booleanDataset(el, 'active', i === index));
    }
  }

  async connectedCallback() {
    await domReady();
    this.refs = refs(this);
    this.#listeners();
    this.#slider();
  }

  #listeners() {
    document.addEventListener('addtocart:error', ({ detail }) => {
      this.refs.message.textContent = detail.message || 'An error occurred while adding to cart.';
      booleanDataset(this.refs.message, 'display', true);
    });

    document.addEventListener('addtocart:added', ({ detail }) => {
      booleanDataset(this.refs.message, 'display', false);
    });

    document.addEventListener('productvariants:price', ({ detail }) => {
      if (this.refs.price) {
        this.refs.price.textContent = detail.price;
      }
    });

    this.refs.next?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slideNext();
      }
    });

    this.refs.prev?.addEventListener('click', (e) => {
      if (this.slider) {
        this.slider.slidePrev();
      }
    });

    this.refs.thumbnails?.forEach(el => {
      el.addEventListener('click', (e) => {
        const index = Array.from(el.parentElement.children).indexOf(el);
        if (this.slider) {
          this.slider.slideTo(index);
        }
      });
    });
  }

  #slider() {
    if (!this.refs.slider) return;

    this.slider = new Swiper(
      this.refs.slider,
      {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false
      }
    );

    this.slider.on('slideChange', () => {
      this.dataset.sliderIndex = this.slider.realIndex;
    });

    this.dataset.sliderIndex = this.slider?.realIndex || 0;
  }
}

customElements.define('product-top', ProductTop);
